import styled from "@emotion/styled";

export const Container = styled.div``;

export const StyledIframe = styled.iframe`
  inline-size: 100%;
`;
